export default "__VITE_ASSET__tIly_LoN__"